import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { ac, systemAdmin, businessAdmin, user } from "./permissions";

export const authClient = createAuthClient({
    baseURL: import.meta.env.VITE_API_URL,
    plugins: [
        adminClient({
            ac,
            roles: {
                systemAdmin,
                businessAdmin,
                user,
            },
        }),
    ],
});

export const hasPermission = (role: string, permissions: Record<string, string[]>): boolean => {
    return authClient.admin.checkRolePermission({ permissions, role });
};
